<p-toast></p-toast>

<!-- ─── Scrollable content ────────────────────────────────────────────────── -->
<div class="skid-spec-content">

    <div class="grid p-3">

        <!-- Column 1: Sales Info -->
        <div class="col-12 md:col-4">
            <div class="card p-3">
                <h4 class="section-title">Sales Info</h4>

                <div class="info-field">
                    <span class="field-label">Project Number</span>
                    <span class="field-value">{{ projectInfo.projectNumber || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Project Name</span>
                    <span class="field-value">{{ projectInfo.projectName || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Project Manager</span>
                    <span class="field-value">{{ projectInfo.projectManager || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Engineer</span>
                    <span class="field-value">{{ projectInfo.engineer || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Project Coordinator</span>
                    <span class="field-value">{{ projectInfo.projectCoordinator || '—' }}</span>
                </div>
            </div>
        </div>

        <!-- Column 2: Customer Info -->
        <div class="col-12 md:col-4">
            <div class="card p-3">
                <h4 class="section-title">Customer Info</h4>

                <div class="info-field">
                    <span class="field-label">Customer Name</span>
                    <span class="field-value">{{ projectInfo.customerName || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Site Contact</span>
                    <span class="field-value">{{ projectInfo.siteContact || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Contact (Phone) #</span>
                    <span class="field-value">{{ projectInfo.customerContactNumber || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Email Address</span>
                    <span class="field-value">{{ projectInfo.customerEmailAddress || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Address 1</span>
                    <span class="field-value">{{ projectInfo.customerAddress1 || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Address 2</span>
                    <span class="field-value">{{ projectInfo.customerAddress2 || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">City</span>
                    <span class="field-value">{{ projectInfo.customerCity || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">State</span>
                    <span class="field-value">{{ projectInfo.customerState || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Zip</span>
                    <span class="field-value">{{ projectInfo.customerZip || '—' }}</span>
                </div>
            </div>
        </div>

        <!-- Column 3: Skid Information -->
        <div class="col-12 md:col-4">
            <div class="card p-3">
                <h4 class="section-title">MV Power Station Information</h4>

                <div class="info-field">
                    <span class="field-label">Transformer</span>
                    <span class="field-value">{{ projectInfo.transformerName || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Integrator</span>
                    <span class="field-value">{{ projectInfo.integratorName || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">MV Power Station Configuration <span class="required-star">*</span></span>
                    <div class="skid-config-row">
                        <div class="skid-config-item">
                            <span class="skid-label">N1</span>
                            <span class="skid-value">{{ effectiveSkidParts[0] }}</span>
                        </div>
                        <div class="skid-config-item">
                            <span class="skid-label">N2</span>
                            <span class="skid-value">{{ effectiveSkidParts[1] }}</span>
                        </div>
                        <div class="skid-config-item">
                            <span class="skid-label">N3</span>
                            <span class="skid-value">{{ effectiveSkidParts[2] }}</span>
                        </div>
                        <div class="skid-config-item">
                            <span class="skid-label">N4</span>
                            <span class="skid-value">{{ effectiveSkidParts[3] }}</span>
                        </div>
                        <div class="skid-config-item">
                            <span class="skid-label">N5</span>
                            <span class="skid-value">{{ effectiveSkidParts[4] }}</span>
                        </div>
                        <div class="skid-config-item">
                            <span class="skid-label">N6</span>
                            <span class="skid-value">{{ effectiveSkidParts[5] }}</span>
                        </div>
                        <div class="skid-config-item">
                            <span class="skid-label">N7</span>
                            <span class="skid-value">{{ effectiveSkidParts[6] }}</span>
                        </div>
                        <span class="skid-equals">=</span>
                        <div class="skid-config-item">
                            <span class="skid-label">MVPS</span>
                            <span class="skid-value skid-total">{{ getTotalSkids() }}</span>
                        </div>
                    </div>
                </div>

                <div class="info-field">
                    <span class="field-label">Aux Package</span>
                    <span class="field-value">{{ projectInfo.auxPackage || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Inverter Model</span>
                    <span class="field-value">{{ getInverterModelName() || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Oil Containment</span>
                    <span class="field-value">{{ projectInfo.oilContainment || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Auxiliary Rack Light</span>
                    <span class="field-value">{{ projectInfo.auxiliaryRackLight || '—' }}</span>
                </div>
                <div class="info-field">
                    <span class="field-label">Number of GFCI</span>
                    <span class="field-value">{{ projectInfo.numberGfci || '—' }}</span>
                </div>
            </div>
        </div>

    </div>

    <!-- Manager Notes -->
    <div class="card p-3 mx-3 mb-3">
        <h4 class="section-title">Manager Notes</h4>
        <p-editor [(ngModel)]="projectInfo.managerNotes" [style]="{ height: '160px' }"></p-editor>
    </div>

</div>

<!-- ─── Docked footer ─────────────────────────────────────────────────────── -->
<div class="skid-spec-footer">
    <p-button icon="pi pi-download" label="Export" (click)="exportSkidSpec()"></p-button>
    <p-button *ngIf="canSave" icon="pi pi-save" label="Save" (click)="saveSkidSpec()" [loading]="saving"></p-button>
</div>
